var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative","height":"100%"}},[_c('div',{staticClass:"hide-text"},[_vm._v(" ADIBLAR XIYOBONI ")]),_c('iframe',{ref:"iframe",attrs:{"src":_vm.iframeSrc,"width":"100%","height":"100%","frameborder":"0","scrolling":"yes"}}),_c('div',{staticClass:"scrolling-text"})])
}
var staticRenderFns = []

export { render, staticRenderFns }